// extracted by mini-css-extract-plugin
export default {"wrap":"crop_wrap__bNRw0","add":"crop_add__xJMR0","svg":"crop_svg__B2N8p","btn":"crop_btn__39pzp","btnAdd":"crop_btnAdd__P4ywC"};